import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SoundManager} from "./resource/sound/SoundManager";
import {WGSoundConfig} from "./WGSoundConfig";
import {WGGameAssets} from "./WGGameAssets";
import {WarriorGraveyardGameModuleConfig} from "./WarriorGraveyardGameModuleConfig";


export class WarriorGraveyardPromoPanelConfig implements PromoPanelGameConfiguration {
    private wasFeatureBuy: boolean = false;

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "WarriorGraveyard",
            hasActionSpin: true,
            graphics: {backgroundTextureName: WGGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: any, bet: number, prevResponse: any): ASWinData => {
                if (response.mode === GameMode.NORMAL) {
                    this.wasFeatureBuy = response.wasFeatureBuy;
                }
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    totalSpinWinnings: this.getWin(response, bet, prevResponse),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank
                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            SoundManager.playSoundEffect(WGSoundConfig.instance.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SoundManager.playSoundEffect(WGSoundConfig.instance.AS_WIN_BIG);
        }
    }

    private isBigWin(response: any): boolean {
        const win = response.totalSpinWinnings;
        const playedBetValue = response.playedBetValue;
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);
        if (response.wasFeatureBuy) {
            const betPrice: number = WarriorGraveyardGameModuleConfig.featurePrice.getBuyFeaturePriceAS(response);
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }
        return winRatio >= 15;
    }

    private getWin(response: any, bet: number, prevData: any): number {
        return response.totalSpinWinnings;
    }

    private getFeatureName(response: any): string {
        if (response.mode === GameMode.NORMAL && response.nextMode === GameMode.FREESPIN) {
            if (response.superFreespin) {
                return "DEATH SPINS";
            } else {
                return "GRAVEYARD SPINS";
            }
        } else if (response.mode === GameMode.FREESPIN && response.nextMode === GameMode.NORMAL) {
            if (response.superFreespin) {
                return "DEATH SPINS";
            } else {
                return "GRAVEYARD SPINS";
            }
        } else {
            if (response.mode === GameMode.FREESPIN && response.superFreespin) {
                return "DEATH SPINS";
            } else if (response.mode === GameMode.FREESPIN && response.superFreespin === false) {
                return "GRAVEYARD SPINS";
            } else {
                return "";
            }
        }
    }

    private isFreeSpinTriggered(response: any): boolean {
        return response.freespinTriggeredThisSpin;
    }

    private isRoundComplete(response: any): boolean {
        return true;
    }

    private isBonusEnd(response: any): boolean {
        return response.nextMode === GameMode.NORMAL && (response.mode.indexOf("NORMAL") === -1);
    }
}